import { render, staticRenderFns } from "./switch-list.vue?vue&type=template&id=b8c9d0f6&functional=true"
var script = {}
import style0 from "./switch-list.vue?vue&type=style&index=0&id=b8c9d0f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports